import { gql } from '@/__generated__/gql';

export const GET_TOTAL_LIST_ADVISORS_QUERY = gql(`
  query FatInvestorsPageListFirmsTotal($data: FirmListInputDto!) {
    listFirms(data: $data) {
      total
    }
  }
`);

export const GET_TOTAL_LIST_INVESTORS_QUERY = gql(`
  query FatInvestorsPageListInvestorsTotal($data: InvestorListInputDto!) {
    listInvestors(data: $data) {
      total
    }
  }
`);

export const GET_TOTAL_LIST_ENTITY_QUERY = gql(`
  query FatInvestorsPageListEntitiesTotal($data: LegalEntityListInputDto!) {
    listEntities(data: $data) {
      total
    }
  }
`);

export const LIST_ADVISORS_QUERY = gql(`
  query FatInvestorsPageListFirms($data: FirmListInputDto!) {
    listFirms(data: $data) {
      data {
        id
        investmentCount
        investorCount
        name
        totalCommitments
        totalValue
        type
      }
      totals {
        investorCount
        investmentCount
        totalValue
        totalCommitments
      }
      page
      perPage
      total
    }
  }
`);

export const LIST_INVESTORS_QUERY = gql(`
  query FatInvestorsPageListInvestors($data: InvestorListInputDto!) {
    listInvestors(data: $data) {
      data {
        id
        name
        familyId
        investmentCount
        totalValue
        totalCommitments
        tenant {
          name
        }
      }
      totals {
        investmentCount
        totalValue
        totalCommitments
      }
      total
      page
      perPage
    }
  }
`);

export const LIST_ENTITY_QUERY = gql(`
  query FatInvestorsPageListEntities($data: LegalEntityListInputDto!) {
    listEntities(data: $data) {
      data {
        id
        entityName
        investmentCount
        totalEntityValue
        totalCommitments
        ignoreAllocationTargets
        ignoreBiteSize
        defaultBiteSize1
        defaultBiteSize2
        isGroup
        family {
          id
          name
        }
        tenant {
          name
        }
        advisor {
          initials
        }
      }
      totals {
        investmentCount
        totalValue
        totalCommitments
      }
      total
      page
      perPage
    }
  }
`);

export const LIST_ENTITIES_FOR_ALLOCATION_QUERY = gql(`
  query BeginAllocationModalEntitiesForAllocation($data: EntitiesForAllocationInput!) {
    entitiesForAllocation(data: $data) {
      id
      entityName
    }
  }
`);

export const ALL_ADVISORY_FIRM_LIST_QUERY = gql(`
  query FatInvestorsPageAllAdvisoryFirmList($data: AdvisoryFirmListDto) {
    allAdvisoryFirmList(data: $data) {
      id
      name
      type
      userCount
    }
  }
`);

export const GET_INVESTOR_LEGAL_ENTITIES_IDS_QUERY = gql(`
  query InvestorsPageGetInvestorLegalEntitiesIds($data: getInvestorDto!) {
    getInvestor(data: $data) {
      legalEntities {
        id
        isGroup
      }
    }
  }
`);
